import { useState } from "react";

import { TableAccessModal } from "@/components/common/modals/table-access-modal";

import {
  ContextMenuItem,
  ContextMenuSeparator
} from "@/components/ui/context-menu";

import Relation from "../shared/relations";
import AddColumn from "./add-column";
import ChangeSize from "./change-size";
import TablePadding from "./padding";
import RemoveTable from "./remove-table";
import TableToolbar from "./table-toolbar";
import TableTheme from "./theme";

interface Props extends React.ComponentProps<"div"> {
  editorRef: React.RefObject<HTMLDivElement>;
  rightClickedElement: HTMLElement;
}

const TableContextAction: React.FC<Props> = ({
  editorRef,
  rightClickedElement
}) => {
  const [isAccessModalOpen, setIsAccessModalOpen] = useState(false);

  const tableElement =
    (rightClickedElement.closest("table") as HTMLTableElement | null) || null;
  const tableId = tableElement?.id || "";

  return (
    <>
      <ContextMenuItem
        className="flex items-center justify-between"
        onSelect={(event) => {
          event.preventDefault();
          if (!tableElement) return;

          setIsAccessModalOpen(true);
        }}
      >
        دسترسی
      </ContextMenuItem>
      <AddColumn rightClickedElement={rightClickedElement} />
      <ChangeSize rightClickedElement={rightClickedElement} />
      <TableTheme rightClickedElement={rightClickedElement} />
      <TablePadding rightClickedElement={rightClickedElement} />
      <TableToolbar rightClickedElement={rightClickedElement} />
      <Relation
        editorRef={editorRef}
        rightClickedElement={rightClickedElement}
      />
      <ContextMenuSeparator />
      <RemoveTable rightClickedElement={rightClickedElement} />

      <TableAccessModal
        isOpen={isAccessModalOpen}
        tableId={tableId}
        table={tableElement}
        includeWildcard={true}
        wildcardLabel="کل جدول"
        onClose={() => setIsAccessModalOpen(false)}
      />
    </>
  );
};
export default TableContextAction;
